import FilterButton from "../ui/FilterButton";
import SearchBox from "../ui/SearchBox";
import * as MarkerIcons from "../MapMarkerIcons";
var FilterManager = /** @class */ (function () {
    function FilterManager(map) {
        var _this = this;
        var _a;
        this.filterCategory = [];
        this.filterRadius = 0;
        this.filterButtons = [];
        this.map = map;
        this.filterCenter = map.startingLocation;
        var parent = map.container.parentElement;
        // filter buttons
        parent
            .querySelectorAll("button.agilis-map-filter")
            .forEach(function (it) {
            return _this.filterButtons.push(new FilterButton(it, _this.toggleFilterBtn.bind(_this)));
        });
        // search box
        var searchParent = parent.querySelector(".agilis-map-search-container");
        this.searchBox = new SearchBox(searchParent.querySelector("input.input-location"), searchParent.querySelector("select.select-radius"), searchParent.querySelector("button.search-btn"), searchParent.querySelector("datalist.autocomplete-items"), map.startingLocation, this.searchBoxCallback.bind(this));
        // reset button
        (_a = parent
            .querySelector(".reset-fillter-button")) === null || _a === void 0 ? void 0 : _a.addEventListener("click", this.reset.bind(this));
    }
    FilterManager.prototype.applyFilter = function () {
        var _this = this;
        this.map.mapMarker.forEach(function (it) {
            var inRange = _this.filterRadius == 0 ||
                _this.filterCenter.calcDistanceMeters(it.location) <=
                    _this.filterRadius;
            var matchesCategoryFilter = _this.filterCategory.indexOf(it.category) != -1;
            if (inRange && matchesCategoryFilter) {
                it.addTo(_this.map);
                //it.show();
            }
            else {
                it.remove();
                //it.hide();
            }
        });
    };
    FilterManager.prototype.reset = function () {
        this.filterButtons.forEach(function (it) { return it.reset(); });
        this.searchBox.reset();
        this.filterCenter = this.map.startingLocation;
        this.filterRadius = 0;
        this.filterCategory = [];
        this.searchBox.resetLastLocation(this.filterCenter);
        this.applyFilter();
        this.map.setCenter(this.map.startingLocation);
    };
    FilterManager.prototype.toggleFilterBtn = function (btn) {
        var i = this.filterCategory.indexOf(btn.category);
        if (i == -1) {
            this.filterCategory.push(btn.category);
        }
        else {
            this.filterCategory.splice(i, 1);
        }
        this.applyFilter();
    };
    FilterManager.prototype.searchBoxCallback = function (location, radius) {
        var _a;
        this.filterCenter = location;
        this.filterRadius = radius;
        this.map.setCenter(location);
        (_a = this.marker) === null || _a === void 0 ? void 0 : _a.remove();
        this.marker = this.map.createMarker(location, MarkerIcons.Uncategorized, false);
        this.applyFilter();
    };
    return FilterManager;
}());
export default FilterManager;
